import React from 'react';
import GaugeChart from 'react-gauge-chart';
import { Row, Column } from 'react-foundation';
import BlurContent from '../../../shared/BlurContent';

const OpportunityGauge = (props) => {
	const curTheme = props.curTheme;
	const colors = props.colors;
	const mask_content = props.mask_content;

	// functionally was created considering only 3 sections
	const gaugeborders = [0, 42, 52, 70];
	const gaugeLen = gaugeborders[3] - gaugeborders[0];

	return (
		<div className="gauge">
			<div className="gauge-title">Opportunity score</div>
			<div className="blurred">
				<BlurContent on={mask_content} />
				<GaugeChart
					style={{ height: 130 }}
					textColor={
						mask_content
							? '#cccccc'
							: curTheme.opportunity_score <= gaugeborders[1]
							? colors[0]
							: curTheme.opportunity_score <= gaugeborders[2]
							? colors[1]
							: colors[2]
					}
					colors={[colors[0], colors[1], colors[2]]}
					arcsLength={[
						(gaugeborders[1] - gaugeborders[0]) / gaugeLen,
						(gaugeborders[2] - gaugeborders[1]) / gaugeLen,
						(gaugeborders[3] - gaugeborders[2]) / gaugeLen,
					]}
					percent={
						mask_content
							? 0
							: (curTheme.opportunity_score - gaugeborders[0]) /
							  gaugeLen
					}
					cornerRadius={15}
					arcWidth={0.1}
					arcPadding={0.02}
					fontSize="30"
					needleColor="#cccccc"
					needleBaseColor={
						mask_content
							? '#cccccc'
							: curTheme.opportunity_score <= gaugeborders[1]
							? colors[0]
							: curTheme.opportunity_score <= gaugeborders[2]
							? colors[1]
							: colors[2]
					}
					formatTextValue={
						mask_content
							? (value) => 0
							: (value) => curTheme.opportunity_score
					}
				/>
				<div className="gauge-info-container">
					<Row>
						<Column small={4}>
							<div
								className="gauge-info"
								style={{ color: '#6351FB' }}
							>
								{' '}
								Purple{' '}
							</div>
							<div className="gauge-info">
								{' '}
								{gaugeborders[0] + '-' + gaugeborders[1]}{' '}
							</div>
						</Column>
						<Column small={4}>
							<div
								className="gauge-info"
								style={{ color: '#FF9A02' }}
							>
								{' '}
								Orange{' '}
							</div>
							<div className="gauge-info">
								{' '}
								{gaugeborders[1] +
									1 +
									'-' +
									gaugeborders[2]}{' '}
							</div>
						</Column>
						<Column small={4}>
							<div
								className="gauge-info"
								style={{ color: '#28AD25' }}
							>
								{' '}
								Green{' '}
							</div>
							<div className="gauge-info">
								{' '}
								{gaugeborders[2] +
									1 +
									'-' +
									gaugeborders[3]}{' '}
							</div>
						</Column>
					</Row>
				</div>
				<div className="gauge-text">
					A score depicting the opportunities an organization can
					leverage using the theme. This score is based on hehaviour,
					emotion and impact metrics.
				</div>
			</div>
		</div>
	);
};

export default OpportunityGauge;
